import axios from "axios";
import { setAuthToken } from "shared/utils/setAuthToken";

/*const LogOutHandler = () => {
  //const { onLogout } = useAuth();
  //const navigate = useNavigate();
  setAuthToken("", "");
  // navigate("/auth");
  window.location.href = "/auth";
  // onLogout();
};*/

const $apiRefresh = axios.create({
  //withCredentials: true,
  baseURL: process.env.REACT_APP_API_PATH,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

$apiRefresh.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("refreshToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const $api = axios.create({
  //withCredentials: true,
  baseURL: process.env.REACT_APP_API_PATH,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

$api.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

/**
 * Catch the AunAuthorized Request
 */
$api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      localStorage.getItem("refreshToken")
    ) {
      if (error.config.isRetry !== true) {
        originalRequest.isRetry = true;
        try {
          await $apiRefresh.get("/auth/refresh").then((response) => {
            const { accessToken } = response.data;
            setAuthToken(accessToken, "");
            window.location.reload();
          });
        } catch {
          //LogOutHandler();
        }
      } else {
        // LogOutHandler();
      }
    }
    return Promise.reject(error);
  },
);

export default $api;
